<template>
    <div class="about-root">
        <div class="about-bg"></div>
        <div class="about-content">
            <h2 class="about-title">About XigFor</h2>
            <div class="about-underline"></div>
            <p class="about-p">XigFor is a social commerce platform designed for peer-to-peer interactions around second-hand goods, content sharing, and community engagement.</p>
            <p class="about-p">
                Users can list items, discover products through posts and short-form content, and interact with others through comments, messages, and social features.<br />
                XigFor focuses on facilitating user-driven discovery and marketplace interactions rather than operating as a traditional retailer.
            </p>
            <p class="about-p">
                In addition to core marketplace functionality, XigFor provides optional digital platform features that enhance content visibility, user engagement, and participation experience.<br />
                These features are designed to support platform usage and community activity and are not required to complete transactions.
            </p>
            <p class="about-p">
                XigFor operates as a platform service provider and does not offer financial services, investment products, revenue-sharing arrangements, or cash-based rewards.<br />
                Any participation indicators, scores, or non-cash credits displayed on the platform are used solely to reflect user activity and engagement within the platform experience.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'About'
}
</script>

<style scoped>
.about-root {
    position: relative;
    width: 100%;
    /* background: #fff; */
    overflow: hidden;
    max-width: 1400px;
    margin: 0 auto;
}
.about-bg {
    position: absolute;
    inset: 0;
    /* background: url('@/assets/bg_bottom.png') center/cover no-repeat; */
    /* opacity: 0.35; */
    z-index: 1;
    margin: 32px 40px;
    border-radius: 24px;
}
/* 移除 .about-bg */
.about-content {
    position: relative;
    z-index: 2;
    padding: 48px;
    /* 可选：加个半透明背景提升可读性 */
    /* background: rgba(255,255,255,0.85);
  border-radius: 20px; */
    /* max-width: 1040px; */
}
.about-title {
    font-family: 'Inter', Arial, sans-serif !important;
    font-size: 50px;
    font-weight: 700;
    color: #393944;
    margin-bottom: 8px;
}
.about-bold {
    font-weight: 800;
    color: #222;
}
.about-underline {
    width: 76px;
    height: 4px;
    background: #f7455d;
    border-radius: 2px;
    margin-bottom: 40px;
}
.about-p {
    color: #6c6c78;
    font-size: 22px;
    line-height: 40px;
    margin-bottom: 32px;
    font-weight: 300;
    font-family: 'Inter Light', 'Inter', sans-serif;
    /* max-width: 900px; */
}
@media (max-width: 900px) {
    .about-bg {
        margin: 16px 12px;
        border-radius: 16px;
    }
    .about-content {
        padding: 18px 14px;
        background: rgba(255, 255, 255, 0.94);
        max-width: none;
    }
    .about-title {
        font-size: 1rem;
        margin-bottom: 10px;
    }
    .about-underline {
        width: 48px;
        height: 4px;
        margin-bottom: 16px;
    }
    .about-p {
        font-size: 11px;
        line-height: 18.04px;
        margin-bottom: 16px;
        color: #6c6c78;
        font-weight: 300;
        font-family: 'Inter Light', 'Inter', Arial, sans-serif;
    }
    .pc-br {
        display: none;
    }
    .about-root {
        padding: 0 0 8px 0;
        background-size: cover;
    }
}
</style>
